export const Download = (props) => {
  return (
    <div id="download" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.data ? props.data.title : 'Loading...'}</h2>
          <p>{props.data ? props.data.paragraph : 'Loading...'}</p>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <div className="row">
              <div className="col-md-6">
                <div className="download-item download-card">
                  <i className="fa fa-apple fa-4x" aria-hidden="true"></i>
                  <h3>{props.data ? props.data.ios.title : 'iOS'}</h3>
                  <p>{props.data ? props.data.ios.text : 'Loading...'}</p>
                  <a href={props.data ? props.data.ios.link : '#'} className="btn btn-custom btn-lg">
                    {props.data ? props.data.ios.button : 'App Store'}
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <div className="download-item download-card">
                  <i className="fa fa-android fa-4x" aria-hidden="true"></i>
                  <h3>{props.data ? props.data.android.title : 'Android'}</h3>
                  <p>{props.data ? props.data.android.text : 'Loading...'}</p>
                  <a href={props.data ? props.data.android.link : '#'} className="btn btn-custom btn-lg">
                    {props.data ? props.data.android.button : 'Google Play'}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
